import React from "react";
import Title from "../Title";
import { Container, ContentImage, Image, Loading } from "./style";

type Params = {
  logo: string;
  name: string;
};

export const LoadingRedirect = ({ logo, name }: Params) => {
  return (
    <Container>
      <div>
        <Title>Redirecionando para o login com a operadora</Title>
      </div>
      <ContentImage>
        <div>
          <Image src={logo} alt={name} />
        </div>
        <Loading>
          <svg
            width="64"
            height="64"
            viewBox="0 0 64 64"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M51.1667 32C51.1667 21.3961 43.1039 13.3333 32.5 13.3333V8C45.7548 8 56.5 18.7452 56.5 32H51.1667Z"
              fill="currentColor"
            />
            <path
              d="M32.5 50.6667C43.1039 50.6667 51.1667 42.6039 51.1667 32L56.5 32C56.5 45.2548 45.7548 56 32.5 56V50.6667Z"
              fill="currentColor"
            />
            <path
              d="M13.8333 32C13.8333 42.6039 21.8961 50.6667 32.5 50.6667V56C19.2452 56 8.5 45.2548 8.5 32H13.8333Z"
              fill="currentColor"
            />
          </svg>
        </Loading>
      </ContentImage>
    </Container>
  );
};
